const centsToString = (cents, trimZeroes = true, showWithCommas = true, showInCents = false) => {
    let isNegative = cents < 0;
    let absoluteCents = Math.abs(cents);

    if (showInCents && absoluteCents < 100) {
        return `${isNegative ? '- ' : ''}${absoluteCents}\u00A2`;
    }

    let dollars = (absoluteCents / 100).toFixed(2);

    if (trimZeroes && parseFloat(dollars) % 1 === 0) {
        dollars = parseInt(dollars).toString();
    }

    if (showWithCommas) {
        dollars = dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    return `${isNegative ? '- ' : ''}$${dollars}`;
};

export {centsToString};
